import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ReactFocusLock from 'react-focus-lock';
import { HeaderConteudoMenuMobileAvatarFragment } from '../header-conteudo-menu-mobile-avatar/header-conteudo-menu-mobile-avatar.fragment';
import S from './conteudo-menu-mobile-avatar.styles';
import { Props } from './conteudo-menu-mobile-avatar.types';

export const ConteudoMenuMobileAvatarFragment: React.FC<Props> = ({ conteudo, rodape, onClose, menuAberto }) => {
  const [exibirConteudo, setExibirConteudo] = useState<boolean>(false);
  const [fecharConteudo, setTransicaoFecharConteudo] = useState<boolean>(false);

  const modalRootContainer = document.querySelector('#modal-root');

  const focarElementoHtml = (idElemento: string) => {
    const elemento = document.getElementById(idElemento);
    elemento?.focus();
  };

  useEffect(() => {
    if (!menuAberto) {
      setTimeout(() => setExibirConteudo(false), 400);
    } else {
      setExibirConteudo(true);
      focarElementoHtml('conteudo-menu-mobile-avatar');
    }
  }, [menuAberto]);

  const component = (
    <>
      {exibirConteudo && (
        <ReactFocusLock>
          <S.ConteudoMenuMobileAvatar
            aria-label="Você está no menu"
            transicaoExibirConteudo={exibirConteudo}
            transicaoFecharConteudo={fecharConteudo}
            data-section="section_menu-principal"
            data-testid="conteudo-menu-mobile-avatar"
            id="conteudo-menu-mobile-avatar"
          >
            <HeaderConteudoMenuMobileAvatarFragment
              onClick={() => {
                setTransicaoFecharConteudo(true);
                setTimeout(() => onClose(), 400);
              }}
            />

            <S.ScrollMenuMobileAvatar>{conteudo}</S.ScrollMenuMobileAvatar>

            <S.Footer>{rodape}</S.Footer>
          </S.ConteudoMenuMobileAvatar>
        </ReactFocusLock>
      )}
    </>
  );

  if (modalRootContainer) {
    return createPortal(component, modalRootContainer);
  }

  return component;
};
